import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1b2896ab&scoped=true&"
import script from "@/scripts/App/index.js?vue&type=script&lang=js&"
export * from "@/scripts/App/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2896ab",
  null
  
)

export default component.exports